import CompartmentLabel from './CompartmentLabel';

export default CompartmentLabel;
